// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_TermRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_TermRow — one version of the agreement of one MARKET,
 * with all of its language variants.
 *
 * THE PLAN IS THE KEY: you agree to the terms of the thing you are buying. At
 * most one version per plan is `ativo`, whatever languages it carries. Keying
 * it per language, as an earlier cut did, let one plan hold two live
 * agreements at once — different clauses and different hashes decided by the
 * reader's language, which is two contracts rather than a translation.
 *
 * `plano_nome` is the plan's CURRENT display name, resolved for the console;
 * `plan_id` is the tie. Repricing a plan supersedes its row, and the lookup
 * follows that chain backwards so the agreement is not orphaned.
 *
 * `variants` is ordered pt-BR first: it is the authoring language and the one
 * an operator translates from.
 */
import type { SubscriptionTerms_VariantRow } from './SubscriptionTerms_VariantRow'
import { registerContract } from './validate'

export interface SubscriptionTerms_TermRow {
id: number
plan_id?: number
plano_nome?: string
titulo?: string
versao?: string
ativo?: boolean
aceites?: number
deactivated_at?: string
created_by?: string
created_at?: string
updated_at?: string
variants?: SubscriptionTerms_VariantRow[]
}

registerContract('SubscriptionTerms_TermRow', {
  id:             { type: 'number',  required: true },
  plan_id:        { type: 'number',  required: false },
  plano_nome:     { type: 'string',  required: false },
  titulo:         { type: 'string',  required: false },
  versao:         { type: 'string',  required: false },
  ativo:          { type: 'boolean', required: false },
  aceites:        { type: 'number',  required: false },
  deactivated_at: { type: 'string',  required: false },
  created_by:     { type: 'string',  required: false },
  created_at:     { type: 'string',  required: false },
  updated_at:     { type: 'string',  required: false },
  variants: {
    type: 'array',
    required: false,
    items: {
      id:             { type: 'number',  required: true },
      term_id:        { type: 'number',  required: false },
      language:       { type: 'string',  required: false },
      conteudo:       { type: 'string',  required: false },
      content_sha256: { type: 'string',  required: false },
      updated_by:     { type: 'string',  required: false },
      created_at:     { type: 'string',  required: false },
      updated_at:     { type: 'string',  required: false },
    },
  },
})
